import { ISearchMeta } from '../types/searchMeta';

export function buildSubdomainRedirectUrl({ subdomain, querystring }: ISearchMeta) {
  const hostSplit = window.location.host.split('.');
  const domain = `${subdomain}.${hostSplit[hostSplit.length - 2]}.${hostSplit[hostSplit.length - 1]}`;

  return `${window.location.protocol}//${domain}${window.location.pathname}?${querystring}`;
}
